import { NATALIE_REQUEST_EVENT_ID_KEY } from 'natalie/constants';

/**
 * Whether the given event is the create_event ("Request Natalie Session") event
 * the user reached via the Request flow this session. Mirrors isRequestNatalieEvent
 * for events that can't be listed in the static VITE_APP_NATALIE_REQUEST_EVENT_IDS
 * allowlist: the per-community create_event id is dynamic, so the Request success
 * effect stashes it in sessionStorage and the participant screens gate the
 * non-anonymous copy on a match here.
 *
 * @param eventId - The Natalie event ID being rendered
 * @returns true when it matches the stashed request-flow event id
 */
export const isCreateEventRequestFlow = (eventId: string): boolean => {
  try {
    return !!eventId && sessionStorage.getItem(NATALIE_REQUEST_EVENT_ID_KEY) === eventId;
  } catch {
    return false;
  }
};
